require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-topological-sort.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-topological-sort");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-topological-sort!./.cache/json/coding-interview-prep-rosetta-code-topological-sort.json
// module id = 1916
// module chunks = 231608221292675